export const AND = 'and'
export const OR = 'or'

export const LOGIC_SIGN_NAME = {
  [AND]: '且',
  [OR]: '或',
}
